export const gulpParam = 'gulp';
export const owsServerParam = 'owsserver';
export const owsApiParam = 'owsapi';

export type HttpMethod =
    | 'POST'
    | 'PATCH'
    | 'PUT'
    | 'GET'
    | 'DELETE'
    | 'HEAD'
    | 'OPTIONS'
    | 'CONNECT'
    | 'TRACE';

export interface PrimeServiceError extends Error {
    /** correlationVector for distributed tracing */
    correlationVector: string;
    /** correlationId for FrontEnd-Begin and FrontEnd-End stamping in FE server*/
    correlationId: string;
}
